import React from "react";
import { FaRobot } from "react-icons/fa6";
import { FaShapes } from "react-icons/fa6";
import { GrNotes } from "react-icons/gr";
import { FaRegClock } from "react-icons/fa6";
import { PiNotebookLight } from "react-icons/pi";
import { CiMobile1 } from "react-icons/ci";
import { MdLightbulbOutline } from "react-icons/md";
import {FaArrowRight } from "react-icons/fa";
import Form from 'react-bootstrap/Form';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { FaUser } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const Services = () => {

    const navigate = useNavigate();

   const background ={
     background: '#EEEE',
     padding: '20px',
     paddingBottom: '50px',
   }    

    const now = 25;

    const [selectedService, setSelectedService] = useState(null);

  return (
        <>
                <div className="container mt-5">
                  <div className="row top">
                    <div className="col-md-4">
                    <div className="nav-option mb-3 option1 active">
                      <FaShapes className="side" />
                    <p className="" onClick={() => navigate("/start-project")}>Services</p>
                    </div>
                    <div className="nav-option mb-3 option1">
                      <GrNotes className="side" />
                    <p className="" onClick={() => navigate("/project")}>Project Details</p>
                    </div>
                    <div className="nav-option mb-3 option1">
                      <FaRegClock className="side" />
                      <p onClick={() => navigate("/timeline")}>Timeline & Budget</p>
                    </div>
                    <div className="nav-option option1">
                      <FaUser className="side" />
                      <p>Contact Info</p>
                    </div> 
                    <div className="mt-5 mb-5">
                        <h4 style={{color: '#353995', fontWeight: '700'}}>Step 1 of 4</h4>
                        <p>Let’s build  something great.</p>
                        <ProgressBar
                            now={now}
                            label={`${now}%`} 
                            variant="" 
                            >
                            <div
                                style={{
                                width: `${now}%`,
                                backgroundColor: "#F29235",
                                height: "100%",
                                transition: "width 0.6s ease"
                                }}
                            />
                        </ProgressBar>
                    </div>                       
                    </div>
                <div className="col-md-8" style={background}>
                <div className="p-4">
                    <h1 style={{fontWeight: '700', fontSize: '55px'}}>What can we help you with?</h1>
                    <p>Select the services that align with you project goals. you can choose multiple options</p>
                </div>
                <div className="row">
                <div className="col-md-6 mt-4">
                <div
                    onClick={() => setSelectedService("ai")}
                    className={`service-card d-flex gap-3 p-3 ${
                    selectedService === "ai" ? "selected" : ""
                    }`}
                >
                    <div style={{ fontSize: "50px", color: "#939394" }}>
                    <FaRobot style={{ background: "#EEEE", color: '#F29235', borderRadius: "8px" }} />
                    </div>

                    <div className="flex-grow-1">
                    <h6 style={{ color: "#353995", fontWeight: '700' }}>AI SOLUTIONS</h6>
                    <p>LLMs, automation, and predictive analysis</p>
                    </div>

                    {selectedService === "ai" && (
                    <FaCheckCircle
                        size={30}
                        color="#F29235"
                        style={{ alignSelf: "center" }}
                    />
                    )}
                </div>
                </div>                   
                <div className="col-md-6 mt-4">
                <div
                    onClick={() => setSelectedService("web")}
                    className={`service-card d-flex gap-3 p-3 ${
                    selectedService === "web" ? "selected" : ""
                    }`}
                >
                    <div style={{ fontSize: "50px", color: "#939394" }}>
                    <PiNotebookLight style={{ background: "#EEEE", color: '#F29235', borderRadius: "8px" }} />
                    </div>

                    <div className="flex-grow-1">
                        <h6 style={{color: '#353995', fontWeight: '700'}}>Web Design</h6>
                        <p>Custom B2B platforms and marketing sites</p>
                    </div>

                    {selectedService === "web" && (
                    <FaCheckCircle
                        size={30}
                        color="#F29235"
                        style={{ alignSelf: "center" }}
                    />
                    )}
                </div>
                </div>                   
                <div className="col-md-6 mt-4">
                <div
                    onClick={() => setSelectedService("mobile")}
                    className={`service-card d-flex gap-3 p-3 ${
                    selectedService === "mobile" ? "selected" : ""
                    }`}
                >
                    <div style={{ fontSize: "50px", color: "#939394" }}>
                    <CiMobile1 style={{ background: "#EEEE", color: '#F29235', borderRadius: "8px" }} />
                    </div>

                    <div className="flex-grow-1">
                        <h6 style={{color: '#353995', fontWeight: '700'}}>Mobile Apps</h6>
                        <p>Native IOS/ Android and cross-platform apps.</p>
                    </div>
                    {selectedService === "mobile" && (
                    <FaCheckCircle
                        size={30}
                        color="#F29235"
                        style={{ alignSelf: "center" }}
                    />
                    )}
                </div>
                </div>                   
                <div className="col-md-6 mt-4">
                <div
                    onClick={() => setSelectedService("cloud")}
                    className={`service-card d-flex gap-3 p-3 ${
                    selectedService === "cloud" ? "selected" : ""
                    }`}
                >
                    <div style={{ fontSize: "50px", color: "#939394" }}>
                    <MdLightbulbOutline style={{ background: "#EEEE", color: '#F29235', borderRadius: "8px" }} />
                    </div>

                    <div className="flex-grow-1">
                    <h6 style={{ color: "#353995", fontWeight: '700' }}>Product Strategy</h6>
                    <p>Roadmapping and market validation.</p>
                    </div>

                    {selectedService === "cloud" && (
                    <FaCheckCircle
                        size={30}
                        color="#F29235"
                        style={{ alignSelf: "center" }}
                    />
                    )}
                </div>
                </div>                                      
              <div>
                  <h3 className="mt-5">Tell us about your project goals</h3>
                    <Form.Group className="mb-3 mt-4 box-shadow" controlId="exampleForm.ControlTextarea1">
                       <Form.Control placeholder="Describe what you’re looking to achieve" as="textarea" rows={10} />
                    </Form.Group> 
                    <div className="text-end">
                       <button className="step" onClick={() => navigate("/project")}>Next Step <FaArrowRight /></button> 
                    </div>   
                                
              </div>

                </div>
    
                </div> 
                </div>
                </div>
        </>


  );
}

export default Services;
